"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _prefixUrl = require("@mapbox/batfish/modules/prefix-url");
var _routeTo = require("@mapbox/batfish/modules/route-to");
var _searchAutofillDemoIos = _interopRequireDefault(require("../../../video/search-autofill-demo-ios.mp4"));
var _iphoneFrame = _interopRequireDefault(require("../../../components/iphone-frame"));
var _relatedPage = _interopRequireDefault(require("@mapbox/dr-ui/related-page"));
var _note = _interopRequireDefault(require("@mapbox/dr-ui/note"));
var _pageShell = _interopRequireDefault(require("/work/ios-sdk/src/components/page-shell.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var frontMatter = {
  title: 'Address Autofill',
  description: 'Mobile Form Autofill for iOS Search SDK.',
  contentType: 'guide',
  layout: 'page',
  tag: 'new',
  order: 3,
  language: ['Swift'],
  products: ['Search SDK for iOS'],
  headings: [{
    text: 'User experience',
    slug: 'user-experience',
    level: 2
  }, {
    text: 'Integration',
    slug: 'integration',
    level: 2
  }]
};
var MarkdownReact = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarkdownReact, _React$PureComponent);
  var _super = _createSuper(MarkdownReact);
  function MarkdownReact() {
    _classCallCheck(this, MarkdownReact);
    return _super.apply(this, arguments);
  }
  _createClass(MarkdownReact, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_pageShell["default"], _extends({}, props, {
        frontMatter: frontMatter
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Suppose you need a user to enter a valid home or delivery address. They typically need to do this during the registration or checkout process, where making the entry process as smooth as possible can help you prevent churn. This is where enabling users to fill in the address form by entering only a few characters is the most beneficial."), /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-ml"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col w-1/2-ml"
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        id: "user-experience",
        className: "anchor"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#user-experience",
        className: "unprose color-blue-on-hover"
      }, "User experience")), /*#__PURE__*/_react["default"].createElement("ol", null, /*#__PURE__*/_react["default"].createElement("li", null, "Whenever it\u2019s time to fill in the address in your app, the user is presented with a form. The top field in the form is focused for input."), /*#__PURE__*/_react["default"].createElement("li", null, "When the user starts typing, a list of valid, matching addresses is displayed, with the addresses closest to the user presented first."), /*#__PURE__*/_react["default"].createElement("li", null, "The user taps one of the suggested addresses and the form fields are filled."), /*#__PURE__*/_react["default"].createElement("li", null, "Your app shows the map with a pin placed for the selected address, which enables the user to visually confirm that they selected the correct address."), /*#__PURE__*/_react["default"].createElement("li", null, "Users also have the option of adding a comment for a housing unit, specific delivery instructions, or confirm the address they otherwise would need to type in manually.")), /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col w-1/2-ml px12 wmin180"
      }, /*#__PURE__*/_react["default"].createElement(_iphoneFrame["default"], {
        src: _searchAutofillDemoIos["default"],
        title: "Form autofill with visual map confirmation.",
        rotation: "portrait"
      }))), /*#__PURE__*/_react["default"].createElement("p", null, "We have a ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://github.com/mapbox/mapbox-search-ios/tree/main/Sources/Demo"
      }, "ready-made sample app"), " that you can try in Xcode with Address Autofill and other scenarios. We encourage you to install and try it for yourself."), /*#__PURE__*/_react["default"].createElement(_relatedPage["default"], {
        url: "https://github.com/mapbox/mapbox-search-ios/tree/main/Sources/Demo",
        title: "Full example of Address Form Autofill",
        contentType: "example"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Learn how to integrate Search SDK Address Autofill with UI for suggestions, filled-in form components, and a visual map confirmation (includes Maps SDK) in a sample app.")), /*#__PURE__*/_react["default"].createElement("h2", {
        id: "integration",
        className: "anchor"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#integration",
        className: "unprose color-blue-on-hover"
      }, "Integration")), /*#__PURE__*/_react["default"].createElement(_relatedPage["default"], {
        url: "/ios/search/guides/install/",
        title: "Installation guide",
        contentType: "guide"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "Before using any of Mapbox's Search products, you need to do some common installation steps. Please follow this guide, then continue with the steps below.")), /*#__PURE__*/_react["default"].createElement("ol", null, /*#__PURE__*/_react["default"].createElement("li", null, "Get ", /*#__PURE__*/_react["default"].createElement("code", null, "AddressAutofill"), " instance:")), /*#__PURE__*/_react["default"].createElement("pre", {
        className: "language-swift"
      }, /*#__PURE__*/_react["default"].createElement("code", {
        className: "language-swift"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " addressAutofill ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token operator"
      }, "="), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token class-name"
      }, "AddressAutofill"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n")), /*#__PURE__*/_react["default"].createElement("ol", {
        start: 2
      }, /*#__PURE__*/_react["default"].createElement("li", null, "Add a request for input from the user:")), /*#__PURE__*/_react["default"].createElement("pre", {
        className: "language-swift"
      }, /*#__PURE__*/_react["default"].createElement("code", {
        className: "language-swift"
      }, "addressAutofill", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "suggestions"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "for"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token class-name"
      }, "AddressAutofill"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token class-name"
      }, "Query"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "value", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), " yourQueryString", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token operator"
      }, "!"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ","), "\n", "    ", "with", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token class-name"
      }, "AddressAutofill"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token class-name"
      }, "Options"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "{"), " result ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "in"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "switch"), " result ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "{"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "case"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "success"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " suggestions", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), "\n", "        ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "show"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "suggestions", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n", "    ", "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "case"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "failure"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " error", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), "\n", "        ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "print"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "error", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "}"), "\n")), /*#__PURE__*/_react["default"].createElement("ol", {
        start: 3
      }, /*#__PURE__*/_react["default"].createElement("li", null, "When a user has selected a suggestion, call ", /*#__PURE__*/_react["default"].createElement("code", null, "select(suggestion:completion:)"), " method. This method returns either an error or ", /*#__PURE__*/_react["default"].createElement("code", null, "AddressAutofill.Result"), " struct that provides detailed information about the address, such as ", /*#__PURE__*/_react["default"].createElement("code", null, "AddressComponents"), ".")), /*#__PURE__*/_react["default"].createElement("pre", {
        className: "language-swift"
      }, /*#__PURE__*/_react["default"].createElement("code", {
        className: "language-swift"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " selectedSuggestion ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token operator"
      }, "="), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "pickSuggestion"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "suggestions", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n", "addressAutofill", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "select"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "suggestion", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), " selectedSuggestion", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "{"), " result ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "in"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "switch"), " result ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "{"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "case"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "success"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " suggestionResult", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), "\n", "        ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token comment"
      }, "// process result"), "\n", "        ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " addressComponents ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token operator"
      }, "="), " suggestionResult", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), "addressComponents", "\n", "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "case"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "."), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "failure"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token keyword"
      }, "let"), " error", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ":"), "\n", "        ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token function"
      }, "print"), /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "("), "error", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, ")"), "\n", "    ", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "}"), "\n", /*#__PURE__*/_react["default"].createElement("span", {
        className: "token punctuation"
      }, "}"), "\n", "        ", "\n")), /*#__PURE__*/_react["default"].createElement(_relatedPage["default"], {
        url: "/ios/search/api-reference/",
        title: "API Reference",
        contentType: "glossary"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "For more information, see the full API reference for the iOS Search SDK.")), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_note["default"], {
        title: "Want to use Autofill on your website?"
      }, /*#__PURE__*/_react["default"].createElement("p", null, "For using Address Autofill on the web see our ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://docs.mapbox.com/mapbox-search-js/guides/autofill/"
      }, "Mapbox Search JS SDK"), "."))));
    }
  }]);
  return MarkdownReact;
}(_react["default"].PureComponent);
exports["default"] = MarkdownReact;